import { Schema } from 'rsuite'

const { StringType } = Schema.Types

export default Schema.Model({
  email: StringType()
    .isRequired('Поле обязательно для заполнения')
    .isEmail('Введите корректный e-mail'),
  password: StringType()
    .minLength(8, 'Минимум 8 знаков')
    .isRequired('Поле обязательно для заполнения')
})
